import './password.scss';
import React from 'react';
import { Translate, translate, getUrlParameter } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button, Alert } from 'reactstrap';
import { Redirect, RouteComponentProps, Link } from 'react-router-dom';
import MessageModal from 'app/shared/message/message-modal';
import { IRootState } from 'app/shared/reducers';
import { savePassword, reset, getUserInfo } from './password.reducer';
import { SUCCESS } from 'app/config/constants';
import UserInfo from './user-info';
import { login } from 'app/shared/util/utilities';

export interface IUserPasswordProps extends StateProps, DispatchProps, RouteComponentProps<{ username: any; key: any }> {}

export interface IUserPasswordState {
  password: string;
  visible: boolean;
  color: string;
  message: string;
  redirectLogin: boolean;
  showMessage: boolean;
  isMobile: boolean;
  disableButtonReg: boolean;
  username: string;
  key: string;
}

export class PasswordPage extends React.Component<IUserPasswordProps, IUserPasswordState> {
  state: IUserPasswordState = {
    password: '',
    visible: false,
    color: 'info',
    message: '',
    redirectLogin: false,
    showMessage: false,
    isMobile: false,
    disableButtonReg: false,
    username: '',
    key: ''
  };

  componentWillMount() {
    let username = this.props.match.params.username;
    let key = getUrlParameter('key', this.props.location.search);

    window['is_mobile']();
    this.setState({
      isMobile: window['isMobile'],
      username: username,
      key: key
    });

    this.props.getUserInfo(username, key);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.userRequest !== nextProps.userRequest) {
      const { userRequest } = nextProps;
      if (userRequest.status === 'SUCCESS') {
        this.setState({
          showMessage: true
        });
        let timerId = setTimeout(() => {
          this.setState({
            showMessage: false,
            redirectLogin: true
          });
        }, 3000);
      } else if (userRequest.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: userRequest.message && userRequest.message !== 'ERROR' ? userRequest.message : translate('register.messages.error.fail')
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
    }
  }

  handleValidSubmit = (event, values) => {
    const { username, key } = this.state;
    let password = values.newPassword;
    if (password && password.indexOf(' ') > -1) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Mật khẩu không được chứa khoảng trắng.'
      });
    } else {
      this.props.savePassword(username, key, values.newPassword);
      this.setState({
        disableButtonReg: true
      });
    }
  };

  updatePassword = event => {
    this.setState({ password: event.target.value });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    const username = this.props.userInfo ? this.props.userInfo.cn : '';
    const message = 'Đặt mật khẩu cho tài khoản ' + username + ' thành công!';
    if (this.state.redirectLogin) {
      login(this.props.config);
    }
    return (
      <div>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={message} />

        <Row className="justify-content-center">
          <Col className="box-password" style={{ maxWidth: '445px' }}>
            <UserInfo />
          </Col>
          <Col className="box-password">
            <h1 className="text-center font-weight-bold" id="register-title">
              Đặt mật khẩu
            </h1>
            <h3 className="text-center txtContent">
              <Translate contentKey="password.txtContent" />
            </h3>
            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <AvForm id="password-form" onValidSubmit={this.handleValidSubmit}>
              <AvField
                name="newPassword"
                label={translate('global.form.password.label')}
                placeholder={translate('global.form.password.placeholder')}
                type="password"
                validate={{
                  required: { value: true, errorMessage: translate('global.messages.validate.newpassword.required') },
                  minLength: { value: 8, errorMessage: translate('global.messages.validate.newpassword.minlength') },
                  maxLength: { value: 30, errorMessage: translate('global.messages.validate.newpassword.maxlength') },
                  pattern: {
                    value: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$',
                    errorMessage: translate('global.messages.validate.newpassword.strengthmessage')
                  }
                }}
                onChange={this.updatePassword}
              />
              {/* <PasswordStrengthBar password={this.state.password} /> */}
              <AvField
                name="confirmPassword"
                label={translate('global.form.confirmpassword.label')}
                placeholder={translate('global.form.confirmpassword.placeholder')}
                type="password"
                validate={{
                  required: { value: true, errorMessage: translate('global.messages.validate.confirmpassword.required') },
                  minLength: { value: 8, errorMessage: translate('global.messages.validate.confirmpassword.minlength') },
                  maxLength: { value: 30, errorMessage: translate('global.messages.validate.confirmpassword.maxlength') },
                  match: {
                    value: 'newPassword',
                    errorMessage: translate('global.messages.error.dontmatch')
                  }
                }}
              />
              <Button className="btn-register" type="submit" disabled={this.state.disableButtonReg} block>
                <Translate contentKey="reset.finish.form.button">Register</Translate>
              </Button>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userRequest: storeState.passwordReg.userRequest,
  config: storeState.applicationProfile.config,
  userInfo: storeState.passwordSet.userInfo
});

const mapDispatchToProps = { savePassword, reset, getUserInfo };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordPage);
